import { create } from "zustand"
import type { LegalResearchAnswer } from "../hooks/useLegalResearchStream"

export interface QaHistoryEntry {
  id: string
  question: string
  answer: LegalResearchAnswer
  askedAt: number
}

interface QaHistoryState {
  entries: QaHistoryEntry[]
  activeId: string | null
  addEntry: (entry: QaHistoryEntry) => void
  selectEntry: (id: string) => void
  clearActive: () => void
  reset: () => void
}

export const useQaHistoryStore = create<QaHistoryState>((set) => ({
  entries: [],
  activeId: null,

  addEntry: (entry) =>
    set((prev) => ({ entries: [entry, ...prev.entries], activeId: entry.id })),

  selectEntry: (id) =>
    set((state) => (state.entries.some((e) => e.id === id) ? { activeId: id } : {})),

  clearActive: () => set({ activeId: null }),

  reset: () => set({ entries: [], activeId: null }),
}))
